import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { LANG_STORAGE_KEY, LANG_STORAGE_KEY_LEGACY } from './constants/mvp';

const savedLang =
  typeof window !== 'undefined'
    ? localStorage.getItem(LANG_STORAGE_KEY) || localStorage.getItem(LANG_STORAGE_KEY_LEGACY)
    : null;
const fallbackLng = savedLang || 'zh';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh',
    lng: fallbackLng,
    debug: false,
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;
